import React from "react"
import Accordion from "react-bootstrap/Accordion"

import { AccordionIndicator } from "shared/ui/accordion/ui/AccordionIndicator"
import { PropertyList } from "shared/ui/property-list/PropertyList"

import { useProductPositionFormProductInformationContext } from "../contexts/ProductPositionFormProductInformationContext"

export const ProductPositionFormAddonsTab = React.memo(() => {
  const { productInformation } =
    useProductPositionFormProductInformationContext()

  return (
    <div className="product-position-form__tab-content product-position-form__tab-content--addons">
      <Accordion className="product-position-form__addons-accordion">
        {productInformation?.addons?.map(addon => (
          <Accordion.Item key={addon.variantKey} eventKey={addon.variantKey}>
            <Accordion.Button className="product-position-form__addons-accordion-button">
              {addon.title}
              <AccordionIndicator />
            </Accordion.Button>
            <Accordion.Body>
              <PropertyList list={addon.attributes ?? []} />
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  )
})
